import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncSelectors, asyncOnError,
} from 'ducks/utils'

export const { types, actions } = createActions({
  asyncs: {
    getBreaks: (query) => (query),
  }
}, 'futureBreaks')

let initialState = asyncInitialState({
  breaksData: null,
})

export default (state = initialState, action) => {
  switch (action.type) {
    case types.getBreaks:
      return asyncOnRequest(state, action)
    case types.saga.getBreaks.success:
      return asyncOnSuccess(state, action, (data, action) => {
        return {
          ...data,
          breaksData: action.payload
        }
      })
    case types.saga.getBreaks.failure:
      return asyncOnError(state, action)
    default:
      return state
  }
}

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.pricing.futureBreaks,
  {
    breaksData: data => data.breaksData
  }
)

const syncSelector = {
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)

